import { closeDatasetNamespacesState } from './state';
import actions from '../../settings/constants';

export default {
  [actions.CLOSE_DATASET_SETTINGS]: closeDatasetNamespacesState,
};
